// auth.js
export const LOGOUT = 'LOGOUT'
export const SAVE_TOKEN = 'SAVE_TOKEN'
export const FETCH_USER = 'FETCH_USER'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'
export const UPDATE_USER = 'UPDATE_USER'

// lang.js
export const SET_LOCALE = 'SET_LOCALE'

// crud.js
export const FETCH_LIST_DESCRIPTION_SUCCESS = 'FETCH_LIST_DESCRIPTION_SUCCESS'
export const FETCH_LIST_DESCRIPTION_FAILURE = 'FETCH_LIST_DESCRIPTION_FAILURE'
export const FETCH_FORM_DESCRIPTION_SUCCESS = 'FETCH_FORM_DESCRIPTION_SUCCESS'
export const FETCH_FORM_DESCRIPTION_FAILURE = 'FETCH_FORM_DESCRIPTION_FAILURE'
export const FETCH_MOCK_DATA_DESCRIPTION_SUCCESS = 'FETCH_MOCK_DATA_DESCRIPTION_SUCCESS'
export const FETCH_MOCK_DATA_DESCRIPTION_FAILURE = 'FETCH_MOCK_DATA_DESCRIPTION_FAILURE'

// userPreferences.js
export const FETCH_USER_PREFERENCES_SUCCESS = 'FETCH_USER_PREFERENCES_SUCCESS'
export const FETCH_USER_PREFERENCES_FAILURE = 'FETCH_USER_PREFERENCES_FAILURE'


// WEBPACK FOOTER //
// ./resources/assets/js/store/mutation-types.js